module.exports = __webpack_public_path__ + "img/img8.3045a5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/03/img8.png
// module id = 230
// module chunks = 0